import { Switch } from "./ui/switch";
import { Label } from "./ui/label";

export function SwitchWithLabel({
  id,
  label,
  checked,
  labelRight,
  onCheckedChange,
  disabled = false,
}) {
  return (
    <div className="flex items-center space-x-2">
      <Label htmlFor={id}>{labelRight}</Label>
      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
          disabled={disabled}
          className="sr-only peer"
        />
        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
      </label>
      <Label htmlFor={id}>{label}</Label>
    </div>
  );
}
